module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-mediumitalic-webfont.fc0a5e2f.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-mediumitalic-webfont.eot
// module id = 100
// module chunks = 3